








































import DecisionChangeCard from "./DecisionChangeCard.vue";
import DecisionCommentView from "./DecisionCommentView.vue";
import { Decision, DecisionVote, decisionResource } from "@megarax/client/src/resources/Decision";
import { createComponent, ref, computed } from "@vue/composition-api";

import ResourceItemHyperlink from "@/components/resource/ResourceItemHyperlink";
import { VNode, VueConstructor } from "vue";
import VoteField from "@/components/VoteField.vue";
import VoteBadge from "@/components/VoteBadge.vue";
import { useActions } from "@/shared/useMegaraxClient";
import { getResourceModule } from "../../apps";

interface Props {
  value: Decision;
}

export default createComponent<Props>({
  components: {
    ResourceItemHyperlink,

    VoteField,
    VoteBadge,
    DecisionCommentView,
    DecisionChangeCard,
  },
  props: {
    value: {
      required: true,
    },
  },
  setup(props, { root }) {
    const resourceModule = getResourceModule(props.value.subjectApp, props.value.subjectResource);

    const decisionActions = useActions(decisionResource);

    async function setMyVote(voteStatus: boolean) {
      if (voteStatus === null) {
        await decisionActions.deleteDecisionVote(props.value);
        root.$notify.success(`Usunięto ocenę.`);
      } else {
        await decisionActions.setDecisionVote(props.value, voteStatus);
        root.$notify.success(`Dodano ocenę.`);
      }
    }

    const newCommentText = ref("");
    async function addComment() {
      const text = newCommentText.value;
      newCommentText.value = "";
      try {
        await decisionActions.addDecisionComment(props.value, text);
        root.$notify.success(`Dodano komentarz.`);
      } catch {
        // bring back the text if the action failed
        newCommentText.value = text;
      }
    }

    return {
      setMyVote,
      newCommentText,
      addComment,
      resourceModule,
    };
  },
  filters: {
    formatDate: (date?: Date) => (date ? date.toLocaleString() : "-"),
  },
});
